var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { FormFieldPrivate } from '../form-field-private';
import { FormFieldHeaderPrivate } from '../form-field-header-private';
import { FormFieldLabelPrivate } from '../form-field-label-private';
import { FormFieldRequiredIndicatorPrivate } from '../form-field-required-indicator-private';
import { FormFieldBodyPrivate } from '../form-field-body-private';
import { ButtonField } from '../button-field';
import { Iconsvg } from '../iconsvg';
import { FormFieldErrorPrivate } from '../form-field-error-private';
import { SrOnly } from '../sr-only';
import { DEFAULT_SUCCESS_FIELD_I18N, DEFAULT_REQUIRED_FIELD_I18N } from '../forms-lib';
import { randomId } from '../lib-randomId';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
export var DEFAULT_PASSWORD_I18N = {
    successLabel: 'Success',
    revealPasswordText: 'Show',
    hidePasswordText: 'Hide',
    required: DEFAULT_REQUIRED_FIELD_I18N,
    success: DEFAULT_SUCCESS_FIELD_I18N,
};
var PasswordField = /** @class */ (function (_super) {
    __extends(PasswordField, _super);
    function PasswordField(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.passwordRef = React.createRef();
        _this.modeChange = 'onModeChange';
        _this.state = {};
        _this.state['_status'] = _this.props.status;
        _this.state['_errors'] = _this.props.errors;
        _this.state['successId'] = '';
        _this.onTogglePasswordVisibility =
            _this.onTogglePasswordVisibility.bind(_this);
        return _this;
    }
    PasswordField.prototype.render = function () {
        return (React.createElement(FormFieldPrivate, { hasPassword: true, size: this.props.size, status: this.props.status, mode: this.props.mode, dataFieldInlayItems: this.getDataFieldInlayItems() },
            this.props.label || this.props.srLabel ? (React.createElement(FormFieldHeaderPrivate, null,
                this.props.label ? (React.createElement(FormFieldLabelPrivate, { identifier: this.props.labelId, isHidden: this.props.isLabelHidden, forAttribute: this.props.labelFor, isAriaHidden: this.getIsLabelAriaHidden() },
                    this.props.label,
                    ' ',
                    this.props.indicator === 'required' ? (React.createElement(FormFieldRequiredIndicatorPrivate, { i18n: this.getI18n().required },
                        this.getI18n().required.label,
                        ' ')) : null)) : null,
                this.hasSrLabel() ? (React.createElement("div", { id: this.props.srLabelId, className: "cg-sr-only" }, this.props.srLabel)) : null)) : null,
            React.createElement(FormFieldBodyPrivate, null,
                React.createElement("div", { ref: this.passwordRef, "data-e2e": "cg-input-field-container", className: "cg-input-field-container" },
                    this.props.children,
                    React.createElement(ButtonField, { mode: 'text', iconPosition: 'left' },
                        React.createElement("button", { type: "button", "data-e2e": "cg-field-password-toggle-button", onClick: this.onTogglePasswordVisibility, className: "cg-field-password-toggle-button" },
                            this.props.type === 'password' ? (React.createElement(Iconsvg, { name: "visible" })) : null,
                            this.props.type === 'text' ? (React.createElement(Iconsvg, { name: "invisible" })) : null,
                            this.props.type === 'password' ? (React.createElement("span", null, this.getI18n().revealPasswordText)) : null,
                            this.props.type === 'text' ? (React.createElement("span", null, this.getI18n().hidePasswordText)) : null)),
                    this.isNotValid() ? (React.createElement(React.Fragment, null, Object.values(this.state._errors).map(function (error, i) {
                        return (React.createElement(FormFieldErrorPrivate, { identifier: error.labelId, key: 'cogen-14056' + i.toString() },
                            error.label,
                            ' '));
                    }))) : null,
                    this.props.status === 'success' ? (React.createElement("div", { "data-e2e": "cg-field-inlay", id: this.state.successId, role: "alert", className: "cg-field-inlay" },
                        React.createElement("span", { title: this.getI18n().successLabel, className: "cg-field-icon cg-field-check-mark-icon" },
                            React.createElement(Iconsvg, { name: "check-circle", isFill: true }),
                            React.createElement(SrOnly, null, this.getI18n().success.srLabel)))) : null))));
    };
    PasswordField.prototype.passwordElement = function () {
        var _a;
        return (_a = this.passwordRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input');
    };
    PasswordField.prototype.onTogglePasswordVisibility = function () {
        var mode = this.props.type === 'password' ? 'text' : 'password';
        this.emit(this.modeChange, mode);
    };
    PasswordField.prototype.getI18n = function () {
        return __assign(__assign({}, DEFAULT_PASSWORD_I18N), this.props.i18n);
    };
    PasswordField.prototype.hasSrLabel = function () {
        return this.props.srLabel !== undefined;
    };
    PasswordField.prototype.getIsLabelAriaHidden = function () {
        var srLabel = this.props.srLabel;
        return srLabel === '' || srLabel !== undefined;
    };
    PasswordField.prototype.getDataFieldInlayItems = function () {
        return this.props.status === 'success' ? 1 : 0;
    };
    PasswordField.prototype.setDescriptiveFieldsId = function () {
        if (this.props.status === 'success') {
            this.writeState('successId', randomId());
        }
    };
    PasswordField.prototype.isIdChanged = function (prevProps) {
        var _this = this;
        var props = ['successId', '_errors'];
        return props.some(function (prop) { return _this.isStateChanged(prop, prevProps); });
    };
    PasswordField.prototype.cg_change = function (prevProps) {
        var _a, _b;
        if (this.isPropChanged('error', prevProps) ||
            this.isPropChanged('errors', prevProps)) {
            var currentErrors = this.props.error
                ? [this.props.error]
                : this.props.errors;
            this.writeState('_errors', __spreadArray([], currentErrors, true));
        }
        if (this.isPropChanged('status', prevProps)) {
            this.writeState('_status', this.props.status);
        }
        if (this.isIdChanged(prevProps)) {
            var describedBy = __spreadArray([
                this.state.successId
            ], this.state._errors.map(function (error) { return error.labelId; }), true).join(' ')
                .trim();
            if (describedBy.length) {
                (_a = this.passwordElement()) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-describedby', describedBy);
            }
            else {
                (_b = this.passwordElement()) === null || _b === void 0 ? void 0 : _b.removeAttribute('aria-describedby');
            }
        }
    };
    PasswordField.prototype.isPropChanged = function (propName, prevProps) {
        return (prevProps[propName] !== undefined &&
            prevProps[propName] !== this.props[propName]);
    };
    PasswordField.prototype.isStateChanged = function (propName, prevProps) {
        return (prevProps[propName] !== undefined &&
            prevProps[propName] !== this.state[propName]);
    };
    PasswordField.prototype.isNotValid = function () {
        return this.state._status === 'error' && this.state._errors.length > 0;
    };
    PasswordField.prototype.componentDidMount = function () {
        this.setDescriptiveFieldsId();
        if (this.props.error) {
            this.writeState('_errors', [this.props.error]);
        }
    };
    PasswordField.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    PasswordField.defaultProps = {
        status: 'none',
        size: 'large',
        mode: 'default',
        isLabelHidden: false,
        errors: [],
        i18n: DEFAULT_PASSWORD_I18N,
        type: 'password',
        indicator: 'none',
    };
    PasswordField.displayName = 'PasswordField';
    return PasswordField;
}(React.Component));
export { PasswordField };
